







import { Component, Prop, Vue } from 'vue-property-decorator';
import { IApexChartConfig } from '@/plugins/apexcharts/ApexChartConfig';

@Component
export default class DoughnutChart extends Vue {
	@Prop({}) series!: number[];
	@Prop({}) labels!: string[];
	@Prop({}) labelColors!: string[];
	@Prop({ type: String }) title!: string;
	@Prop({ type: String, default: '100%' }) width!: string;
	@Prop({ type: String, default: '100%' }) height!: string;

	get Options(): IApexChartConfig {
	    return {
	        chart: {
	            type: 'pie'
	        },

	        plotOptions: {
	            pie: {
	                expandOnClick: false
	            }
	        },

	        stroke: {
	            show: true,
	            curve: 'smooth',
	            lineCap: 'round',
	            colors: undefined,
	            width: 0.5,
	            dashArray: 0
	        },

	        title: {
	            text: this.title,
	            align: 'right',
	            style: {
	                fontSize: '18px',
	                color: '#fff'
	            },
	            offsetY: 50,
	            floating: true
	        },

	        labels: this.labels,

	        colors: this.labelColors,

	        fill: {
	            opacity: 1,
	            type: 'gradient',
	            gradient: {
	                shade: 'dark',
	                type: 'vertical',
	                shadeIntensity: 0.3,
	                inverseColors: false,
	                opacityFrom: 1,
	                opacityTo: 0.7,
	                stops: [25, 100]
	            }
	        },

	        legend: {
	            show: true,
	            itemMargin: {
	                vertical: 1
	            },
	            labels: {
	                useSeriesColors: true
	            },
	            position: 'top',
	            offsetY: 0,
	            floating: false
	        }
	    };
	}

	get Series() {
	    return this.series;
	}
}
